// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b8654872","453":"b7fd5d66"}[chunkId] + ".chunk.js";
};